// extracted by mini-css-extract-plugin
export default {"Emojify":"bbe_a bhf_g"};